/*
 * rheincool — Lieferdatum-Countdown (Produktdetail-Handoff §4)
 *
 * Vor Cut-off: "Bestellen Sie innerhalb von X Std. Y Min. → Lieferung {Datum}"
 * Nach Cut-off / am Wochenende: nur "Lieferung {Datum}" — kein Fake-Timer.
 * Versandtage: Mo–Fr. Lieferdatum = Versandtag + Laufzeit, auf Werktag gerundet.
 * Aktualisierung minütlich.
 */
class RcDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector('[data-delivery-text]');
    if (!this.textEl) return;
    this.update();
    this.timer = setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  /* Nächster Werktag ab date (inklusive date selbst, wenn Mo–Fr) */
  toWorkday(date) {
    const d = new Date(date);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }

  /* n Werktage auf date addieren — Samstag und Sonntag zählen nicht mit.
     Vorher wurden Kalendertage addiert und erst das Ergebnis auf einen
     Werktag gerundet; ab Versand am Donnerstag lag das Lieferdatum dadurch
     ein bis zwei Tage zu früh. */
  addWorkdays(date, n) {
    const d = new Date(date);
    let offen = n;
    while (offen > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() >= 1 && d.getDay() <= 5) offen -= 1;
    }
    return d;
  }

  update() {
    const now = new Date();
    const [h, m] = (this.dataset.cutoff || '14:00').split(':').map(Number);
    const cutoff = new Date(now);
    cutoff.setHours(h, m, 0, 0);

    const isWorkday = now.getDay() >= 1 && now.getDay() <= 5;
    const beforeCutoff = isWorkday && now < cutoff;

    let shipDay;
    if (beforeCutoff) {
      shipDay = new Date(now);
    } else {
      shipDay = new Date(now);
      shipDay.setDate(shipDay.getDate() + 1);
      shipDay = this.toWorkday(shipDay);
    }

    const deliveryDate = this.addWorkdays(shipDay, parseInt(this.dataset.transitDays || '3', 10));

    const dateLabel = deliveryDate.toLocaleDateString('de-DE', {
      weekday: 'short',
      day: 'numeric',
      month: 'long',
    });

    // Zeit + Datum fett hervorheben (Template und Werte sind vertrauenswürdig:
    // Locale-String + toLocaleDateString)
    let text;
    if (beforeCutoff) {
      const mins = Math.max(1, Math.round((cutoff - now) / 60000));
      const hours = Math.floor(mins / 60);
      const rest = mins % 60;
      const span = hours > 0 ? `${hours} Std. ${rest} Min.` : `${rest} Min.`;
      text = (this.dataset.countdownText || '')
        .replace('[zeit]', `<b>${span}</b>`)
        .replace('[datum]', `<b>${dateLabel}</b>`);
    } else {
      text = (this.dataset.plainText || '').replace('[datum]', `<b>${dateLabel}</b>`);
    }

    this.textEl.innerHTML = text;
    this.hidden = false;
  }
}

customElements.define('rc-delivery-estimate', RcDeliveryEstimate);
